import { formatISO, isSameDay } from 'date-fns';

const esFechaISO = (cadena: string) => {
  try {
    const fecha = new Date(cadena);
    return formatISO(fecha) === cadena;
  } catch (error) {
    return false;
  }
};

export const sonObjetosIguales = (
  obj1: Record<any, any>,
  obj2: Record<any, any>
): boolean => {
  if (obj1 === obj2) return true;

  if (
    obj1 == null ||
    obj2 == null ||
    typeof obj1 !== 'object' ||
    typeof obj2 !== 'object'
  ) {
    return false;
  }

  const llaves1 = Object.keys(obj1);
  const llaves2 = Object.keys(obj2);

  if (llaves1.length !== llaves2.length) {
    return false;
  }

  for (const key of llaves1) {
    const valor1 = obj1[key];
    const valor2 = obj2[key];

    if (esFechaISO(valor1) && esFechaISO(valor2)) {
      if (!isSameDay(new Date(valor1), new Date(valor2))) {
        return false;
      }
    } else if (typeof valor1 === 'object' && typeof valor2 === 'object') {
      if (!sonObjetosIguales(valor1, valor2)) {
        return false;
      }
    } else if (valor1 !== valor2) {
      return false;
    }
  }

  return true;
};

export const sonArraysIguales = (arr1: any[], arr2: any[]) => {
  if (!arr1 || !arr2) return false;

  if (typeof arr1 === typeof arr2 && arr1.length === arr2.length) {
    // Comparo que los dos arrays sean del mismo tipo y que tengan los mismos datos
    return arr1.every((e, i) => e === arr2[i]);
  }
  return false;
};
